import * as actions from "@p81-common/shell-core-js/dist/redux/networkBeaconDelete";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.NETWORK_BEACON_DELETE_REQUEST]: (state, action) => ({
    ...state,
    [action.payload.beaconId]: {
      loading: true,
      loaded: false,
      error: null,
      data: null,
    },
  }),

  [actions.NETWORK_BEACON_DELETE_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.beaconId]: {
      loading: false,
      loaded: true,
      error: null,
      data: action.data,
    },
  }),

  [actions.NETWORK_BEACON_DELETE_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    [action.payload.beaconId]: {
      loading: false,
      loaded: false,
      error: action.error,
      data: null,
    },
  }),

  [CURRENT_CHILD_ORGANIZATION_SET]: () => ({ ...initialState }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function networkBeaconDeleteReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
